export const getMatchBadgeClasses = (percentage: number) => {
  if (percentage >= 80) {
    return "bg-green-100 text-green-800";
  } else if (percentage >= 60) {
    return "bg-yellow-100 text-yellow-800";
  } else {
    return "bg-red-100 text-red-800";
  }
};

export const getMatchBadge = (percentage: number) => {
  if (percentage >= 80) {
    return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-800/40 transition-colors cursor-default";
  }
  if (percentage >= 60) {
    return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 hover:bg-yellow-200 dark:hover:bg-yellow-800/40 transition-colors cursor-default";
  }
  return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 hover:bg-red-200 dark:hover:bg-red-800/40 transition-colors cursor-default";
};